module.exports = __webpack_public_path__ + "Lato-Bold.a2fb219c999a8fa6b95a.eot";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/Lato/fonts/Lato-Bold.eot
// module id = ../../../../../src/assets/fonts/Lato/fonts/Lato-Bold.eot
// module chunks = styles